// extracted by mini-css-extract-plugin
export default {"tx":"_16b306fd03","line":"fea0eed0b5"};